export enum LocalStorageActionsEnum {
  added = 'added',
  removed = 'removed',
}
